import { useRouteError } from 'react-router-dom';
import Error500 from 'pages/maintenance/500';

const AppErrorElement = () => {
  const error = useRouteError();

  // Log the error for debugging/monitoring but avoid crashing the UI.
  console.error('Route error:', error);
  return <Error500 />;
};
export default AppErrorElement;
